module.exports = __webpack_public_path__ + "ws.c9d0d1e4908522ca7368.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/ws.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/ws.svg
// module chunks = styles